import { openDB, DBSchema, IDBPDatabase } from 'idb';

const DB_NAME = 'discoverDB';
const DB_VERSION = 1;

const indexedDB = openDB(DB_NAME, DB_VERSION, {
  upgrade(db) {
    db.createObjectStore('googleSearch');
  },
});

export async function getIDB(key: string) {
  return (await indexedDB).get('googleSearch', key);
}
export async function setIDB(key: string, val: string) {
  return (await indexedDB).put('googleSearch', val, key);
}
